export default __webpack_public_path__ + "images/src/assets/fonts/CiscoSansLightOblique-webfont.svg";